/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface UserRequest { 
    confirmNewUserPassword?: string;
    newUserPassword?: string;
    oldUserPassword?: string;
    userEmail?: string;
    userFirstName?: string;
    userId?: string;
    userName?: string;
    userSurname?: string;
}
